import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class MiniBatchDictionaryLearningGraph extends AbstractScatterVisualization {
}
